import type { ReactNode } from 'react'
import React from 'react'

import { ToolbarButton } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import * as S from './styled'

type Props = {
  top: ReactNode
  bottom: ReactNode
  onRemove: () => void
}

export const RuleLayout = ({ top, bottom, onRemove }: Props) => (
  <S.Container>
    <S.InputsContainer>
      <div>{top}</div>
      <S.Bottom>{bottom}</S.Bottom>
    </S.InputsContainer>
    <ToolbarButton icon={CloseIcon} size="small" onClick={onRemove} />
  </S.Container>
)
